import { useId as r, useMemo as s } from "react";
const m = (u, o) => {
  const e = r();
  return s(
    () => o || `cur-${u}-${e}`,
    [u, o, e]
  );
};
export {
  m as u
};
//# sourceMappingURL=use-unique-id-BA9hSqap.js.map
